<script>
	import { superadmin } from "./stores/store.js";
  import Router, { location, link, push } from "svelte-spa-router";
  import Breakpoint from "./componentes/Breakpoint.svelte";

  import Login from "./Login.svelte";
  import Productos from "./Productos.svelte";
  import Ventas from "./Ventas.svelte";
  import Facturas from "./Facturas.svelte";
  import Home from "./Inicio.svelte";
  import EditProducto from "./EditProducto.svelte";
  
  import Config from "./Config.svelte";

  import Usuarios from "./Usuarios.svelte";
  import EditUsuario from "./EditUsuario.svelte";

  import Permisos from "./Permisos.svelte";
  import EditPermiso from "./EditPermiso.svelte";

  import Sucursales from "./Sucursales.svelte";
  import EditSucursal from "./EditSucursal.svelte";

  import Movimientos from "./Movimientos.svelte";
  import EditMovimiento from "./EditMovimiento.svelte";
  import Kardex from "./Kardex.svelte";

  import Clientes from "./Clientes.svelte";
  import EditCliente from "./EditCliente.svelte";

  import Token from "./Token.svelte";
  import Globales from "./Globales.svelte";

  import Stats from "./Stats.svelte";
  import Lotes from "./Lotes.svelte";
  import EditLotes from "./EditLotes.svelte";
  import ViewLotes from "./ViewLotes.svelte";
  

  import NoPermiso from "./NoPermiso.svelte";
  import NotFound from "./NotFound.svelte";
  import { prefix, urlapi,login,iduser,user, miPermiso, permisos_struct, sucursal, sucursalStore } from "./stores/store";
  import { onMount } from "svelte";
  import { postData, isJson, mergeDeep } from "./scripts";

  let cargando=true;

  /*import Verifysession from './components/Verifysession.svelte';
  //import Navbar from "./components/Navbar.svelte";
  import { prefix, urlapi,theme } from "./stores/store";

  
  
  import Clientes from "./Clientes.svelte";
  import Usuarios from "./Usuarios.svelte";
  import Productos from "./Productos.svelte";
  import EditUsuarios from "./EditUsuarios.svelte";
  import EditClientes from "./EditClientes.svelte";
  import EditPedidos from "./EditPedidos.svelte";
  import EditMisdatos from "./EditMisdatos.svelte";
  import Visitas from "./Visitas.svelte";
  import Nuevavisita from "./Nuevavisita.svelte";
  
  
  
  import { mount_component } from 'svelte/internal';*/
  //import Maps from './components/Maps.svelte';

  //if(!localStorage.getItem($prefix+'_token')) { push('/login'); }
  //push('/productos/1')
  //push('/movimiento/new')
  //push('/kardex/10000001')
  //push('/movimiento/10')
  //push('/movimiento/new')
  
  //push('/movimiento/9')
  //push('/ventas')
  //push('cliente/0')
  //push('/token')
  //push('/config')
  

  //push('/usuarios/35967')
  //push('/clientes')
  //push('/')
  //push('/usuarios/35969');
  //push('/usuarios')
  //push('/productos')
  //push('/pedidos/34')
  //push('/pedidos/38')
  //push('/visitas')
  //push('/nuevavisita')

  /*let mapa=false;
  let latitude=0;
  let longitude=0;

  let openMap=(tlatitude,tlongitude)=>{
    latitude=tlatitude;
    longitude=tlongitude;
    mapa=true;
  }*/
  
      //push('/login')

//push('/lotes/new')

/*const a = { e: { a:true }, c: 2 };
const d = { e: { a:false } , f: 2 };

const ad = { ...a, ...d };

console.log('A',a)
console.log('D',d)
console.log('AD',ad)*/
//let nuevo=mergeDeep(obj1, obj2)
//let nuevo={ ...obj1, ...obj2 }
//let nuevo=Object.assign(obj2, obj1);
//console.table('OBJ1')
/*console.table(obj1.usuarios)
console.table('OBJ2')
console.table(obj2.usuarios)
console.table('NUEVO')
console.table(nuevo.usuarios)*/

	onMount(async () => {
      if(localStorage.getItem($prefix+'_token')!==null)
      {
        postData($urlapi, [{ 'token':localStorage.getItem($prefix+'_token'), 'cmd':'login_verificarToken' }])
        .then(data => {

            if(data[0].result===false) {
              localStorage.clear();
              push('/login')
              cargando=false;
            } else {
              $login = true;
              $iduser = data[0].result.iduser;
              $user = data[0].result.username;

              if (data[0].result.sucursal==9999) {
                  $superadmin=true;
                  $sucursal = data[0].result.sucursal_first;
              } else {
                  $superadmin=false;
                  $sucursal = data[0].result.sucursal;
              }
              //$sucursal = data[0].result.sucursal;

              if(isJson( data[0].result.permisos)===true) {
                  $miPermiso=mergeDeep($permisos_struct, JSON.parse(data[0].result.permisos));
              } else {
                  $miPermiso=$permisos_struct;
              }

              postData($urlapi, [{ 'cmd':'sucursales_listAll' }])
              .then(data => {
                  $sucursalStore={}
                  Object.values(data[0].result).map(function(value) {
                    $sucursalStore={...$sucursalStore,[value.id] :value.nombre}
                  });
                  cargando=false;
              });

              
            }
        });
      } else {
        localStorage.clear();
        push('/login')
        cargando=false;
      }

	});

</script>

<!-- <Breakpoint /> -->

{#if cargando===false}
  <Router
    routes={{
      "/": Home,
      "/facturas": Facturas,
      "/ventas": Ventas,
      
      "/login": Login,
      "/productos": Productos,
      "/productos/:id": EditProducto,
      "/config": Config,
      "/usuarios": Usuarios,
      "/usuario/:id": EditUsuario,
      "/permisos": Permisos,
      "/permiso/:id": EditPermiso,

      "/sucursales": Sucursales,
      "/sucursales/:id": EditSucursal,      

      "/clientes": Clientes,
      "/cliente/:id": EditCliente,

      "/movimientos": Movimientos,
      "/movimiento/:id": EditMovimiento,
      "/kardex/:id": Kardex,
      "/token": Token,
      "/globales": Globales,
      "/stats": Stats,
      "/lotes": Lotes,
      
      "/lotes/new": EditLotes,
      "/lotes/:id": ViewLotes,

      "/sinpermiso": NoPermiso,
      "*": NotFound,
    }}
  />
{/if}

<!-- svelte-ignore a11y-invalid-attribute -->


<!-- <Verifysession /> -->

<!-- 
{#if mapa}
  <Maps bind:visible={mapa} latitude={latitude} longitude={longitude}/>
{/if}
<button on:click={()=>openMap('14.63278151658896','-90.51302141999372')}>Abrir mapa 1</button> -->


<!-- <button on:click={()=>
  {mapa=true;
  latitude='4.63278151658896';
  longitude='-90.51302141999372'          
  }}>Abrir mapa 2</button> -->

<!-- <svelte:body class:oscuro={$theme=='OSCURO'}></svelte:body>

<svelte:head>
    {#if $theme=='OSCURO'}
      <style>
        body { background: #2e2e2e !important; }
    </style>
    {/if}
</svelte:head>	



   <!-- content here -->
   <!-- <Router
  routes={{
    "/": Pedidos,
    "/clientes": Clientes,
    "/clientes/:id": EditClientes,
    "/usuarios": Usuarios,
    "/usuarios/:id": EditUsuarios,
    "/productos": Productos,
    "/pedidos/:id": EditPedidos,
    "/login": Login,
    "/misdatos": EditMisdatos,
    "/visitas": Visitas,
    "/nuevavisita": Nuevavisita,
    "/sinpermiso": NoPermiso,
    
    "*": NotFound,
  }}
/> -->

<!-- <style global>
  :global(A) {
    cursor: pointer;
  }

</style> -->

<style>
  :global(.hightext) {
      border-bottom:2px dotted var(--bs-warning);
      font-weight:600;
  }
</style>